export const CustomerTableMenuOptions = [
  { label: <span className="dark:text-white">View</span>, key: "view" },
  // {
  //   label: <span className="dark:text-white">Send Reminder</span>,
  //   key: "sendReminder",
  // },
  {
    label: <span className="dark:text-white">Change Plan</span>,
    key: "changePlan",
  },
  { type: "divider" },
  {
    label: <span className="text-red-600">Cancel Subscription</span>,
    key: "cancelSubscription",
  },
  // { label: <span className="text-red-600">Delete</span>, key: "delete" },
];

export const FeedbackTableMenuOptions = [
  // { label: <span className="dark:text-white">View</span>, key: "view" },
  {
    label: <span className="dark:text-white">Archive</span>,
    key: "archive",
  },
  {
    label: <span className="dark:text-white">Unarchive</span>,
    key: "unarchive",
  },
  { type: "divider" },
  { label: <span className="text-red-600">Delete</span>, key: "delete" },
];

export const dashboardWidgetsItems = [
  {
    label: <span className="dark:text-white">Reset</span>,
    key: "reset",
  },
  // {
  //   type: "divider",
  // },
  // {
  //   label: <span className="text-red-600">Remove</span>,
  //   key: "remove",
  // },
];

export const dashboardWidgetsItemsWithoutReset = [
  {
    label: <span className="dark:text-white">Reset</span>,
    key: "reset",
  },
  // {
  //   type: "divider",
  // },
  // {
  //   label: <span className="text-red-600">Remove</span>,
  //   key: "remove",
  // },
];

export const ticketsTableMenuOptions = [
  { label: <span className="dark:text-white">View</span>, key: "view" },
];
